import type { DependencyList } from 'react';
import { type ReactNode, useEffect } from 'react';

import { sendLog } from '@/lib/utils/send-log';

export function LoggingView({
  children,
  logName,
  data,
  disabled = false,
  dependencies = [],
}: {
  children: ReactNode;
  logName: string;
  data?: Record<string | number, any>;
  disabled?: boolean;
  dependencies?: DependencyList;
}) {
  useEffect(() => {
    if (disabled) {
      return;
    }

    sendLog(logName, data);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [disabled, logName, ...dependencies]);

  return <>{children}</>;
}
